import { render, staticRenderFns } from "./AI_LayerLegend.vue?vue&type=template&id=fa4c545a&scoped=true&"
import script from "./AI_LayerLegend.vue?vue&type=script&lang=js&"
export * from "./AI_LayerLegend.vue?vue&type=script&lang=js&"
import style0 from "./AI_LayerLegend.vue?vue&type=style&index=0&id=fa4c545a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4c545a",
  null
  
)

export default component.exports